import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import StarFilledSvg from "@ant-design/icons-svg/es/asn/StarFilled";
import AntdIcon from "../components/AntdIcon";
var StarFilled = function StarFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StarFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  StarFilled.displayName = 'StarFilled';
}
export default /*#__PURE__*/React.forwardRef(StarFilled);